module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/wasm-module-2.ddd4a80b234564a40707.js");
};